import React from 'react';
import PropTypes from 'prop-types';
import { DEFAULT_TIMEZONE } from '../Utils/timezone';

// Common timezones for booking date/time
export const TIMEZONES = [
  { value: 'Europe/Budapest', label: 'Budapest (CET/CEST)', flag: '🇭🇺' },
  { value: 'Europe/London', label: 'London (GMT/BST)', flag: '🇬🇧' },
  { value: 'Europe/Paris', label: 'Paris (CET/CEST)', flag: '🇫🇷' },
  { value: 'Europe/Berlin', label: 'Berlin (CET/CEST)', flag: '🇩🇪' },
  { value: 'Europe/Rome', label: 'Rome (CET/CEST)', flag: '🇮🇹' },
  { value: 'Europe/Madrid', label: 'Madrid (CET/CEST)', flag: '🇪🇸' },
  { value: 'Europe/Amsterdam', label: 'Amsterdam (CET/CEST)', flag: '🇳🇱' },
  { value: 'Europe/Vienna', label: 'Vienna (CET/CEST)', flag: '🇦🇹' },
  { value: 'Europe/Prague', label: 'Prague (CET/CEST)', flag: '🇨🇿' },
  { value: 'Europe/Warsaw', label: 'Warsaw (CET/CEST)', flag: '🇵🇱' },
  { value: 'Europe/Bucharest', label: 'Bucharest (EET/EEST)', flag: '🇷🇴' },
  { value: 'Europe/Athens', label: 'Athens (EET/EEST)', flag: '🇬🇷' },
  { value: 'Europe/Istanbul', label: 'Istanbul (TRT)', flag: '🇹🇷' },
  { value: 'Europe/Moscow', label: 'Moscow (MSK)', flag: '🇷🇺' },
  { value: 'America/New_York', label: 'New York (EST/EDT)', flag: '🇺🇸' },
  { value: 'America/Los_Angeles', label: 'Los Angeles (PST/PDT)', flag: '🇺🇸' },
  { value: 'Asia/Dubai', label: 'Dubai (GST)', flag: '🇦🇪' },
  { value: 'Asia/Tokyo', label: 'Tokyo (JST)', flag: '🇯🇵' },
  { value: 'UTC', label: 'UTC', flag: '🌍' },
];

/**
 * Reusable timezone selector component
 * Can be used inline (compact mode) or as a form control
 */
function TimezoneSelect({
  value,
  onChange,
  compact,
  className,
  showIcon,
  size,
}) {
  const handleChange = (e) => {
    onChange(e.target.value);
  };

  if (compact) {
    // Compact inline style (used next to date inputs)
    return (
      <small className={`text-muted ${className || ''}`}>
        {showIcon && <i className="fa fa-globe me-1" />}
        <select
          value={value}
          onChange={handleChange}
          style={{
            border: 'none',
            background: 'transparent',
            color: '#6c757d',
            fontSize: 'inherit',
            cursor: 'pointer',
            padding: 0,
          }}
        >
          {TIMEZONES.map((tzOption) => (
            <option key={tzOption.value} value={tzOption.value}>
              {tzOption.label}
            </option>
          ))}
        </select>
      </small>
    );
  }

  // Standard form control style
  return (
    <select
      className={`form-select ${size ? `form-select-${size}` : ''} ${className || ''}`}
      value={value}
      onChange={handleChange}
    >
      {TIMEZONES.map((tzOption) => (
        <option key={tzOption.value} value={tzOption.value}>
          {tzOption.flag}
          {' '}
          {tzOption.label}
        </option>
      ))}
    </select>
  );
}

TimezoneSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  compact: PropTypes.bool,
  className: PropTypes.string,
  showIcon: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'lg']),
};

TimezoneSelect.defaultProps = {
  value: DEFAULT_TIMEZONE,
  compact: false,
  className: '',
  showIcon: true,
  size: null,
};

export default TimezoneSelect;
